import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore } from "@/stores";
import UserSettings from "@/models/frontend/UserSettings";
import IUserSettings from "@/models/responses/IUserSettings";

export const useUserSettingsStore = defineStore('user-settings', {
  state: () => ({
    error: "" as any,
    data: new UserSettings(),
    loadedUserId: 0 as number | undefined,
  }),
  actions: {
    async fetchAll(force = false) {
      const authStore = useAuthStore();

      const { isAuthenticated, user } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;
      if (!force && this.loadedUserId === user.value?.id) return;

      this.error = "";
      await api
        .get<IUserSettings>(`v1.0/user-settings`)
        .then((response) => {
          const userSettingsResponse = response.data;
          if (userSettingsResponse === null) {
            this.data = new UserSettings();
          }
          else {
            this.data = new UserSettings(
              userSettingsResponse.developerMode,
              userSettingsResponse.confirmQuantity,
              userSettingsResponse.showLotVisual,
              userSettingsResponse.showAuditVisual,
              userSettingsResponse.showBarcode,
              userSettingsResponse.cultureName ?? "en",
              userSettingsResponse.lastUsedSiteId,
              userSettingsResponse.colorMode ?? "system",
            );
          }
          this.loadedUserId = user.value?.id;
        })
        .catch((error) => (this.error = error));
    },
    async postUserSettings() {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) return;

      this.error = "";
      await api
        .post<IUserSettings>(`v1.0/user-settings`, this.data)
        .catch((error) => (this.error = error));
    },
    async reset() {
      api.delete(`v1.0/user-settings`)
        .then(() => {
          this.data = new UserSettings();
        })
        .catch((error) => (this.error = error));
    },
  },
});
